import { Col, Icon, Layout, Menu, Row } from 'antd'
import React, { Fragment } from 'react'
import { Link, withRouter, withSiteData } from 'react-static'
import TextFit from 'react-textfit'
import styled, { css } from 'styled-components'
import { styledf } from '../styles/styled-common'
import Breakpoint from './Breakpoint'

const horizontalMenuItemStyle = css`
  [role='menuitem'] {
    height: 100%;
    display: inline-flex;
    align-items: center;
  }
`
const StMenu = styled(Menu)`
  border-bottom: none;
  line-height: inherit !important;
  background: transparent;
  font-size: 1.3em;
  float: left;
  clear: ${({ mode }) => (mode === 'horizontal' ? 'none' : 'both')};

  ${({ mode }) => (mode === 'horizontal' ? horizontalMenuItemStyle : null)}

  .ant-menu-item:nth-child(n-1) {
    padding-right: 20px;
  }

  .ant-menu-submenu:nth-child(2) .ant-menu-submenu-title {
    padding-left: 0;
  }
`

const SubMenu = styled(Menu.SubMenu)`
  line-height: inherit !important;
  /*
  .ant-menu-submenu-title .ant-menu-submenu-arrow {
    opacity: 0.45;
    position: absolute;
    top: 50%;
    right: 4px;
    width: 10px;
    transition: inherit;

    &:before,
    &:after {
      content: '';
      position: absolute;
      vertical-align: baseline;
      background: #fff;
      background-image: -webkit-gradient(
        linear,
        left top,
        right top,
        from(#eee),
        to(#eee)
      );
      background-image: -webkit-linear-gradient(left, #eee, #eee);
      background-image: -o-linear-gradient(left, #eee, #eee);
      background-image: linear-gradient(to right, #eee, #eee);
      width: 6px;
      height: 1.5px;
      border-radius: 2px;
      transition: none;
      transition: 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    }

    &.ant-menu-submenu-active {
      &:before,
      &:after {
      }
    }

    &:before {
      transform: rotate(-45deg) translateX(2px);
    }

    &:after {
      transform: rotate(45deg) translateX(-2px);
    }

    &.ant-menu-submenu-open {
      .ant-menu-submenu-arrow {
        &:before {
          transform: rotate(45deg) translateX(2px);
        }

        &:after {
          transform: rotate(-45deg) translateX(-2px);
        }
      }
    }
  }
    */
`

const SiteName = styled.div`
  /* width: 100%; */
  /* display: inline-block; */
  /* overflow: hidden; */
`

const StRow = styled(Row)`
  padding: 20px 0;
`

const PaddedRow = styled(Row)`
  padding: 10px 0;
`

const MenuRow = styled(PaddedRow)`
  background: #121212;
`

const LogoLink = styledf(['fullWidth', 'raiseOnHover', 'height', 'width'])(
  Link
)`
  height: 100%;
  width: ${p => (p.fullWidth ? '100%' : 'initial')};
  font-family: 'Orbitron';
  font-family: 'Rajdhani';
  font-weight: 500;
  font-size: 2.5em;
  float: right;
  line-height: initial;
  text-align: center;
  height: 100%;
  position: relative;
  // padding: 0 10px;

  span {
    color: ${p => p.theme.antLink} !important;
  }

  .partof {
    color: #fff !important;
    font-family: 'Orbitron';
    font-size: .5rem;
    margin: 3px 0;
  }

  img {
    height: ${p => (p.height ? `${p.height}px` : 'auto')};
    width: ${p => (p.width ? `${p.width}px` : 'auto')};
    max-width: 100%;
    max-height: 100%;

    +span, +div {
      margin-left: 12px;
      overflow: hidden;
    }
  }


  ${({ raiseOnHover }) =>
    raiseOnHover &&
    `&:hover {
      transition: 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform: scale(1.05);
    }`}
`

const SiteLogo = styled(LogoLink)`
  display: flex;
  align-items: center;
  float: left;
`

const MenuItem = Menu.Item

const SubMenuTitle = ({ title, ...props }) => (
  <span>
    {title}
    <Icon type="down" />
  </span>
)

const toMenuComponent = ({ title, link, children }) => {
  if (children) {
    return (
      <SubMenu
        key={title}
        title={title} //˅
        subMenuOpenDelay={0}
        onTitleClick={() => {
          if (link) {
            window.location = link
          }
        }}
      >
        {children.map(toMenuComponent)}
      </SubMenu>
    )
  }

  return (
    <MenuItem key={link}>
      <Link to={link} style={{ color: 'inherit', textDecoration: 'none' }}>
        <span>{title}</span>
      </Link>
    </MenuItem>
  )
}

class Header extends React.Component {
  render() {
    const {
      match,
      location,
      history,
      siteData,
      staticContext,
      colLayout,
      ...props
    } = this.props

    const { menu, site } = siteData

    const broughtBy = broke => (
      <Col lg={8} xs={7} pull={broke ? 1 : 0}>
        <LogoLink
          width={210}
          to="https://www.besthosting.network"
          raiseOnHover={true}
          target="_blank"
        >
          <div className="partof">Brought to you by</div>
          <img
            src={
              'https://cdn.sanity.io/images/dy8ko03k/production/719301c26915092c7cd4b2ac10038e22a600f948-259x95.svg'
            }
          />
        </LogoLink>
      </Col>
    )

    return (
      <Layout.Header {...props}>
        <Breakpoint
          width={992}
          render={broke => (
            <Fragment>
              <PaddedRow type="flex" align="middle" justify="center">
                <Col {...colLayout}>
                  <Row
                    type="flex"
                    align="middle"
                    justify={broke ? 'center' : 'space-between'}
                  >
                    <Col lg={14} xs={22}>
                      <Row>
                        <SiteLogo to="/" height={68} fullWidth={broke}>
                          <img
                            src={`${site.logo}?w=100&h=100&fit=clip`}
                            alt={`${site.name} logo`}
                          />
                          {broke ? (
                            <SiteName>
                              <TextFit>{site.name}</TextFit>
                            </SiteName>
                          ) : (
                            <span>{site.name}</span>
                          )}
                        </SiteLogo>
                      </Row>
                      <Row type="flex" justify="space-between" align="middle">
                        <Col lg={24} xs={16}>
                          <StMenu
                            theme="dark"
                            mode={broke ? 'inline' : 'horizontal'}
                            selectedKeys={[location.pathname]}
                            forceSubMenuRender={true}
                          >
                            {menu.map(toMenuComponent)}
                          </StMenu>
                        </Col>
                        {broke && broughtBy(broke)}
                      </Row>
                    </Col>
                    {!broke && broughtBy(broke)}
                  </Row>
                </Col>
              </PaddedRow>
            </Fragment>
          )}
        />
      </Layout.Header>
    )
  }
}

export default withSiteData(withRouter(Header))



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Header.jsx